import { AiOutlineSliders, AiOutlineBuild } from "react-icons/ai";
import { RiBrush3Line, RiHashtag, RiImageLine, RiFontColor, RiHistoryLine } from "react-icons/ri";
import { TbDashboard, TbCategory, TbLeaf, TbMusic, TbSticker, TbWallpaper } from "react-icons/tb";
import { MdOutlineWallpaper } from "react-icons/md"

const icon = {
  // className: "w-5 h-5 text-inherit",
  size: "20px",
};

export const routes = {
  sidebarRoutes: [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: <TbDashboard {...icon} />,
    }, {
      layout: "sliders",
      name: "Sliders",
      path: "/sliders",
      icon: <AiOutlineSliders {...icon} />,
      subRoutes: [
        {
          name: "Sliders",
          path: "/sliders",
          icon: <AiOutlineSliders {...icon} />,
        }, {
          name: "Tags",
          path: "/slidertags",
          icon: <RiHashtag {...icon} />,
        },
      ]
    }, {
      layout: "themes",
      name: "Themes",
      path: "/themes",
      icon: <RiBrush3Line {...icon} />,
      subRoutes: [
        {
          name: "Themes",
          path: "/themes",
          icon: <RiBrush3Line {...icon} />,
        }, {
          name: "Theme Categories",
          path: "/themecategories",
          icon: <TbCategory {...icon} />,
        }, {
          name: "Tags",
          path: "/themetags",
          icon: <RiHashtag {...icon} />,
        },
      ]
    }, {
      layout: "diys",
      name: "DIYs",
      path: "/diys",
      icon: <AiOutlineBuild {...icon} />,
      subRoutes: [
        // {
        //   name: "DIYs",
        //   path: "/diys",
        //   icon: <AiOutlineBuild {...icon} />,
        // },
        {
          name: "Background",
          path: "/background",
          icon: <RiImageLine {...icon} />,
        }, {
          name: "Background Categories",
          path: "/backgroundcategories",
          icon: <TbCategory {...icon} />,
        }, {
          name: "Effects",
          path: "/effects",
          icon: <TbLeaf {...icon} />,
        }, {
          name: "Font List",
          path: "/fontlist",
          icon: <RiFontColor {...icon} />,
        },
      ]
    }, {
      name: "Sounds",
      path: "/sounds",
      icon: <TbMusic {...icon} />,
    }, {
      name: "Sticker Store",
      path: "/stickerstore",
      icon: <TbSticker {...icon} />,
    }, {
      layout: "wallpaper",
      name: "Wallpaper",
      path: "/wallpaper",
      icon: <TbWallpaper {...icon} />,
      subRoutes: [
        {
          name: "Wallpaper",
          path: "/wallpaper",
          icon: <MdOutlineWallpaper {...icon} />,
        }, {
          name: "Wallpaper Categories",
          path: "/wallpapercategories",
          icon: <TbCategory {...icon} />,
        },
      ]
    }, {
      name: "History",
      path: "/history",
      icon: <RiHistoryLine {...icon} />
    }
  ],
};

export default routes;
